/** The timed material-alpha ramp a body is drawn through, and the two ramps
 *  the original starts on it. */

/** A body entering the world starts at 0 and reaches 1 over half a second
 *  (`InstanceBase.cpp:778-779`, and the same pair at `:89-90`). */
export const SPAWN_FADE_MS = 500;

/** Eunhyeong and the revive affect take a full second either way
 *  (`InstanceBaseEffect.cpp:789,793,807,812,818`). */
export const STEALTH_FADE_MS = 1000;

/** What a stealthed body is held at for the eyes allowed to see it -- its own
 *  player, and anyone `__MainCanSeeHiddenThing` admits
 *  (`InstanceBaseEffect.cpp:805-807`). Everyone else is given 0.0 (`:810-812`),
 *  which this renderer spends by skipping the draw. */
export const STEALTH_VISIBLE_ALPHA = 0.5;

export interface AlphaRamp {
  /** `m_fBaseAlpha`: the alpha `BlendAlphaValue` was called at. */
  readonly fromAlpha: number;
  /** `m_fDstAlpha`. */
  readonly toAlpha: number;
  /** `m_fBaseTime`, on this client's millisecond clock. */
  readonly startedMs: number;
  /** `m_fDuration`, the original's seconds in milliseconds. */
  readonly durationMs: number;
}

/** Where a ramp stands now: linear between the two alphas while it runs, the
 *  destination once it is over (`__BlendAlpha_Update`,
 *  `ActorInstanceBlend.cpp:44-72`). A duration of zero is already over, which
 *  is how the original's `fElapsedTime < m_fDuration` reads it.
 */
export function rampAlpha(ramp: AlphaRamp, nowMs: number): number {
  const elapsedMs = nowMs - ramp.startedMs;
  if (!(elapsedMs < ramp.durationMs)) return ramp.toAlpha;
  if (elapsedMs <= 0) return ramp.fromAlpha;
  return ramp.fromAlpha + (ramp.toAlpha - ramp.fromAlpha) * (elapsedMs / ramp.durationMs);
}

/** `SetAlphaValue(0.0f); BlendAlphaValue(1.0f, 0.5f)` -- the fade every body
 *  is created with (`InstanceBase.cpp:778-779`). */
export function spawnRamp(enteredMs: number): AlphaRamp {
  return { fromAlpha: 0, toAlpha: 1, startedMs: enteredMs, durationMs: SPAWN_FADE_MS };
}

/** `__Assassin_SetEunhyeongAffect`'s two calls, from wherever the body's alpha
 *  had got to (`InstanceBaseEffect.cpp:799-818`): 0.5 while hidden, 1.0 when
 *  the affect drops.
 */
export function stealthRamp(fromAlpha: number, atMs: number, hidden: boolean): AlphaRamp {
  return {
    fromAlpha,
    toAlpha: hidden ? STEALTH_VISIBLE_ALPHA : 1,
    startedMs: atMs,
    durationMs: STEALTH_FADE_MS,
  };
}
